module.exports = __webpack_public_path__ + "static/media/albanil.342448d2.svg";